import { MutationTree } from 'vuex';
import Vue from 'vue';
import { EditableStatus, ListStatus } from '@/store/types';
import { DistributorsMutations, DistributorsState } from '@/store/modules/distributors/types';
import Distributor from './distributor';
import { updateEditable } from '@/store/utils/editable';

export const mutations: MutationTree<DistributorsState> = {
  [DistributorsMutations.SET_LIST](state, payload: Distributor[]) {
    state.list = payload;
  },
  [DistributorsMutations.SET_LIST_STATUS](state, payload: ListStatus) {
    state.listStatus = payload;
  },
  [DistributorsMutations.SET_DISTRIBUTOR](state, distributor: Distributor) {
    Vue.set(state, 'editableDistributor', distributor);
    Vue.set(state, 'currentDistributor', Distributor.clone(distributor));
  },
  [DistributorsMutations.SET_EDITABLE_STATUS](state, editableStatus: EditableStatus) {
    state.editableStatus = editableStatus;
  },
  [DistributorsMutations.UPDATE_EDITABLE]: updateEditable<DistributorsState>('editableDistributor'),
  [DistributorsMutations.UPDATE_INITIAL_EDITABLE]: updateEditable<DistributorsState>('currentDistributor'),
};

export default mutations;
